import request from "@/utils/request"; // 引入请求模块
// 发送验证码
export function sendCode(data) {
  return request({
    url: "/user/sendCheckCode",
    method: "post",
    data: data
  });
}
// 登录
export function login(data) {
  return request({
    url: "/user/loginByMobile",
    method: "post",
    data: data
  });
}
// 个人信息
export function getUserInfo(data) {
  return request({
    url: "/canteen/employee/home",
    method: "get",
    params: data
  });
}
// 就餐记录
export function getEatRecord(data) {
  return request({
    url: "/canteen/employee/eatRecord",
    method: "get",
    params: data
  });
}
// 食堂首页
export function getChiefInfo(data) {
  return request({
    url: "/canteen/chief/home",
    method: "get",
    params: data
  });
}
// 核销就餐码
export function writeOff(data) {
  return request({
    url: "/canteen/chief/writeOff",
    method: "post",
    data
  });
}
// 就餐记录
export function checkRecord(data) {
  return request({
    url: "/canteen/chief/record",
    method: "get",
    params: data
  });
}
